// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-arrow-down[data-v-9a451cbe] {\r\n  font-size: 12px;\n}\n.block[data-v-9a451cbe] {\r\n  padding-bottom: 20px;\r\n  padding-top: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
